import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs';
import { StartUpConfigUiService } from '../service/ui/start-up-config-ui.service';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html'
})
export class ProgressComponent implements OnInit {
  private counterSource: string | null;
  private cSig: string | null;
  private caid: string | null;
  utm_source: string | null;
  utm_campaign: string | null;
  returnCode: string | null;
  preloaderImageUrl: string;

  constructor(
    private startUpConfigUiService: StartUpConfigUiService,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    this.startUpConfigUiService
      .getPreloaderImageUrl()
      .pipe(take(1))
      .subscribe({
        next: (preloaderImageUrl) => {
          this.preloaderImageUrl = preloaderImageUrl;
        }
      });

    const queryParam = this.route.snapshot.queryParamMap;
    this.counterSource = queryParam.get('waitpagetype');
    this.cSig = queryParam.get('c-sig');
    this.caid = queryParam.get('actid');
    this.utm_source = queryParam.get('utm_source');
    this.utm_campaign = queryParam.get('utm_campaign');
    this.returnCode = queryParam.get('returncode');

    setTimeout(() => {
      this.redirectToQuotes();
    }, 1000);
  }

  private redirectToQuotes(): void {
    this.startUpConfigUiService.initialConfig$.pipe(take(1)).subscribe({
      next: (initialConfig) => {
        const cSigSegment = this.cSig ? this.counterSource ? this.counterSource.includes('?') ? `&c-sig=${this.cSig}` : `?c-sig=${this.cSig}` : `?c-sig=${this.cSig}` : '';
        const actidSegment = this.caid ? `&actid=${this.caid}` : '';
        const utmSourceSegment = this.utm_source ? `&utm_source=${this.utm_source}` : '';
        const utmCampaignSegment = this.utm_campaign ? `&utm_campaign=${this.utm_campaign}` : '';
        const returnCodeSegment = this.returnCode ? `&returncode=${this.returnCode}` : '';
        this.document.location.href = `${initialConfig.quotesStartUpUrl}resultados-comparativa/${
          this.counterSource ? this.counterSource : ''
        }${cSigSegment}${actidSegment}${utmSourceSegment}${utmCampaignSegment}${returnCodeSegment}`;
      }
    });
  }
}
